import {
  required,
  minLength,
} from 'vuelidate/lib/validators';

export function isFullName(value) {
  const regex = /^([\w]{2,})+\s+([\w\s]{2,})+$/;
  return regex.test(value);
}
export function isNumberCredit(value) {
  const regex = /^4[0-9]{15}(?:[0-9]{3})?$/;
  return regex.test(value);
}
export function isCreditCard(value) {
  const regex = /^[0-9]{3,4}$/;
  return regex.test(value);
}

export const validateData = {
  first_name: {
    required,
    minLength: minLength(2),
  },
  last_name: {
    required,
    minLength: minLength(2),
  },
  full_name: {
    required,
    isFullName,
  },
  credit_card_num: {
    required,
    isNumberCredit,
  },
  security_code: {
    required,
    isCreditCard,
  },
};
